export default "__VITE_ASSET__f671c2ee__"